import {IWayPointCreationWithCorrectionsSingleVoyage} from "@containers/singleVoyage/types/point";
import {OnShowError} from "@baseTypes/base";
import {IPositionSingleVoyage} from "@containers/singleVoyage/types/position";
import {getRouteGraphhopper} from "@containers/graphhopper/api/api";
import {getLatLngFromPointGeomCoordinates} from "@helpers/geoJson/getLatLngFromPointGeomCoordinates";

export const getPositionFromAllPointsSingleVoyage = async ({points, onShowError,}: {
    points: IWayPointCreationWithCorrectionsSingleVoyage[],
    onShowError?: OnShowError
}): Promise<{
    positions: IPositionSingleVoyage[] | null
}> => {
    const data = await getRouteGraphhopper({
        points: getLatLngsFromPoints(points),
    }, onShowError)
    return {
        positions: data.paths[0].points?.coordinates?.map(([lat, lng]) => {
            return {
                lat,
                lng,
                pointIndex: 1,
            }
        })
    }
}

const getLatLngsFromPoints = (points: IWayPointCreationWithCorrectionsSingleVoyage[]): {
    lat: number,
    lng: number,
}[] => {
    if (!points.length) {
        return []
    }
    const latLngs: {
        lat: number,
        lng: number,
    }[] = []

    points.forEach((point) => {
        latLngs.push(getLatLngFromPointGeomCoordinates(point.geom))
        if (point?.correctionWaypoints?.length >= 1) {
            latLngs.push(...point.correctionWaypoints)
        }
    })

    return latLngs
}